var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deliverable-dates"},[_c('DeliverableStatusOverview',{attrs:{"deliverable":_vm.deliverable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }